import style from "../../../../assets/scss/common/modal/addChildModal.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";
import {useUserAgent} from "../../../../hooks/hooks";

export function ProfileCommonDescription() {
    const { t } = useTranslation("profileInfo");
    const { isMobile } = useUserAgent();
    return(
        <div className={style.addChildInfoDesc}>
            <span className={style.boldDesc}>
              {t('profileInfo.addModal.desc1')}
            </span>
            <br />
            {isMobile
                ? t('profileInfo.addModal.desc3')
                : t('profileInfo.addModal.desc2')
            }
        </div>
    )
}